import { render, staticRenderFns } from "./pending-prescription-form.vue?vue&type=template&id=f5985882&scoped=true&lang=pug&"
import script from "./pending-prescription-form.vue?vue&type=script&lang=ts&"
export * from "./pending-prescription-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5985882",
  null
  
)

export default component.exports